
import { SubDomain } from "../SubDomain.js";
import TimesheetEntry from "./TimesheetEntry.js";

export default class TimesheetEntriesDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, TimesheetEntry.MODEL_NAME);
    this._storage = storage;
  }
  
  list() {
    return this._storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new TimesheetEntry(this.domain, item);
      }
    }

    return new TimesheetEntry(this.domain, {});
  }
  
}